import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class DownTimeTrackingRequest{
    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    downtimeTrackingId:number;

    // @ApiProperty()
    // @IsNotEmpty()
    // @IsAlphanumeric()
    // departmentId:number;


    @ApiProperty()
    @IsOptional()
    updatedUser: string;

    @ApiProperty()
    @IsOptional()
    @IsNumber()
    versionFlag: number;

    @ApiProperty()
    isActive: boolean;

}
 export class DownTimeTrackingPiechartRequest{
    @ApiProperty()
    fromDate:Date;
    @ApiProperty()
    toDate:Date;
 }
 export class DowntimeMachineNameRequest{
    @ApiProperty()
    assetCode?:string;
    assetCategoryId?:number;

 }